import {Injectable} from '@angular/core';
import {Apollo} from 'apollo-angular';
import {PreguntaModel} from '../models/pregunta.model';
import {ALLPREGUNTAS, EDITPREGUNTA, NEWPREGUNTA, PREGUNTA} from '../queries/pregunta.query';

@Injectable()
export class PreguntasServices {

  constructor(private apollo:Apollo){}

  getAllPreguntas(){
    return this.apollo.query({
      query:ALLPREGUNTAS
    });
  }

  getPregunta(id:any){
    return this.apollo.query({
      query:PREGUNTA,
      variables:{
        id:id
      }
    });
  }

  updatePregunta(preg:PreguntaModel){

    let data = JSON.stringify({
      enunciado:preg.enunciado,
      orden:preg.orden,
      peso:preg.peso,
      subcategoria:preg.subcategoria._id
    });

    return this.apollo.mutate({
      mutation:EDITPREGUNTA,
      variables:{
        id: preg._id,
        pregunta:data
      }
    });
  }

  newPregunta(preg:PreguntaModel){
    let data = JSON.stringify(preg);
    return this.apollo.mutate({
      mutation:NEWPREGUNTA,
      variables:{
        pregunta:data
      }
    });
  }

  delPregunta(id:any){
    // return this.apollo.mutate({
    //   mutation:'',
    //   variables:{
    //     id:id
    //   }
    // });
  }



}
